'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseButton(_ref) {
  var closeToast = _ref.closeToast,
      type = _ref.type,
      ariaLabel = _ref.ariaLabel;

  return _react2.default.createElement(
    'button',
    {
      className: 'Toastify__close-button Toastify__close-button--' + type,
      type: 'button',
      onClick: closeToast,
      'aria-label': ariaLabel
    },
    '\u2716'
  );
}

CloseButton.propTypes = {
  closeToast: _propTypes2.default.func,
  arialLabel: _propTypes2.default.string
};

CloseButton.defaultProps = {
  ariaLabel: 'close'
};

exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ./~/react-toastify/lib/components/CloseButton.js
// module id = 1531
// module chunks = 0